import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-black mt-20">
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-4 mb-5">
            <img src={LOGO_URL} alt="High Key" className="h-16 w-16" />
            <div>
              <p className="font-display text-2xl uppercase tracking-tight text-white">High Key</p>
              <p className="text-xs text-gray-500 uppercase tracking-[0.3em]">Cinematic Drops</p>
            </div>
          </div>
          <p className="text-sm text-gray-400 max-w-md">
            A streetwear cannabis label built for the media-launch era. Flower, wax, carts and
            edibles — dropped in seasons, photographed like albums.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/flower" className="hover:text-[var(--hk-orange)]">Flower</Link></li>
            <li><Link to="/shop/wax" className="hover:text-[var(--hk-orange)]">Wax</Link></li>
            <li><Link to="/shop/carts" className="hover:text-[var(--hk-orange)]">Carts</Link></li>
            <li><Link to="/shop/edibles" className="hover:text-[var(--hk-orange)]">Edibles</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">Reach</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[var(--hk-orange)]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--hk-orange)]">Where to Reach Us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 px-6 md:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-600 font-mono-alt tracking-[0.2em] uppercase">
        <span>© 2026 High Key — Must be 21+ • Consume responsibly</span>
        <span>Made loud in the night shift</span>
      </div>
    </footer>
  );
}
